import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import ContactDetailsAndForm from "./sections/ContactDetailsAndForm";
import LocationMap from "./sections/LocationMap";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactHero />
      <ContactDetailsAndForm />
      <LocationMap />
      <Footer />
    </div>;
}